import React, { useCallback, useEffect, useState } from "react";
import { Col, Form, Row, Button, ButtonGroup } from "react-bootstrap";
import { MdOutlineSpeakerNotes } from "react-icons/md";
import { useForms } from "../../use-forms/index";
import { z } from "zod";

const formSchema = z.object({
  first_name: z.string().nonempty("Primeiro nome é obrigatório."),
  last_name: z.string().nonempty("Último nome é obrigatório."),
  nick_name: z.string().nonempty("Nome preferido é obrigatório."),
  gender: z.string().nonempty("Gênero é obrigatório.")
});

//Form step 1
function Index(props) {
  const {
    register,
    setValue,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForms({ validator: formSchema });

  useEffect(() => {
    clearErrors();
    setValue("gender", props.form.gender);
    setValue("last_name", props.form.last_name);
    setValue("first_name", props.form.first_name);
    setValue("nick_name", props.form.nick_name);

  }, []);

  const onSubmitForm = data => {
    //post or validate data to/on api endpoint here
    //on success
    props?.submit(data);
  };

  return (
    <Form
      onSubmit={handleSubmit(onSubmitForm)}
      className="col-12 col-md-5 col-lg-4"
    >
      <div className="background"></div>
      <h2 className="mb-3">
        <MdOutlineSpeakerNotes /> Informações Pessoais
      </h2>
      <p>
        Preencha os campos correspondentes às suas informações pessoais, e salve
        para continuar.
      </p>
      <Row>
        <Form.Group className="mb-2 col-12">
          <Form.Label htmlFor="first_name">
            Primeiro nome
          </Form.Label>
          <Col sm="12">
            <Form.Control
              name="first_name"
              className="mb-3"
              {...register("first_name")}
            />
            {errors.first_name?.message && (
              <div className="text-danger">{errors.first_name?.message}</div>
            )}
          </Col>
        </Form.Group>

        <Form.Group className="mb-2 col-12">
          <Form.Label htmlFor="last_name">
            Último nome
          </Form.Label>
          <Col sm="12">
            <Form.Control
              name="last_name"
              className="mb-3"
              {...register("last_name")}
            />
            {errors.last_name?.message && (
              <div className="text-danger">{errors.last_name?.message}</div>
            )}
          </Col>
        </Form.Group>

        <Form.Group className="mb-2 col-12">
          <Form.Label >
            Como gostaria de ser chamado
          </Form.Label>
          <Col sm="12">
            <Form.Control className="mb-3" {...register("nick_name")} />
            {errors.nick_name?.message && (
              <div className="text-danger">{errors.nick_name?.message}</div>
            )}
          </Col>
        </Form.Group>
        <Form.Group className="mb-2 col-12">
          <Form.Label>
            Gênero
          </Form.Label>
          <Form.Select aria-label="Gênero" {...register("gender")}>
            <option defaultValue={null}>Gênero</option>
            <option value="female">Feminino</option>
            <option value="male">Masculino</option>
            <option value="other">Outro</option>
            {props.entity ? (
              <option selected>{props.entity.gender}</option>
            ) : (
              ""
            )}
          </Form.Select>
          {errors.gender?.message && (
            <div className="text-danger">{errors.gender?.message}</div>
          )}
        </Form.Group>
      </Row>

      <ButtonGroup className="col-12 mt-3">
        <Button
          onClick={props?.back}
          className="btn btn-light btn-large"
          type="button"
        >
          Voltar
        </Button>
        <Button className="btn btn-primary btn-large" type="submit">
          Salvar
        </Button>
      </ButtonGroup>
    </Form>
  );
}

export default Index;
